<div class="m-input-style"
     :class="[{ 'm--is-focus' : isFocus,
              'm--is-readonly': isReadonly,
              'm--is-label-up': isLabelUp,
              'm--is-disabled' : isDisabled,
              'm--is-waiting' : isWaiting,
              'm--has-cursor-pointer' : cursorPointer,
              'm--has-error' : hasError,
              'm--is-valid' : isValid,
              'm--has-label': hasLabel,
              'm--has-value': hasValue,
              'm--is-anim-ready': animReady,
              'm--has-validation-message': hasValidationMessage },
              'm--is-tag-' + tagStyle]"
     @click="onClick"
     @mousedown="onMousedown"
     @mouseup="onMouseup"
     ref="root">
    <div class="m-input-style__main"
        :style="{ width: width, marginTop: labelOffset }">
        <div class="m-input-style__body">
            <label v-if="hasLabel"
                   ref="label"
                   :id="labelId"
                   class="m-input-style__label"
                   :style="{ marginRight: suffixOffset }"
                   :for="labelFor">
                <span class="m-input-style__text">
                    <span>{{ label }}</span>&nbsp;<sup
                        v-if="requiredMarker"
                        class="m-input-style__required-marker"
                        aria-hidden="true"
                    >*</sup>
                </span>
            </label>

            <span v-else
                  class="m-input-style__label"
                  style="z-index: -1;">
                <span class="m-input-style__text">
                    <!-- this markup is mandatory to maintain content height and alignment -->
                </span>
            </span>

            <div class="m-input-style__input"
                 ref="input">
                <div v-if="showPrefix && $slots.prefix"
                     class="m-input-style__prefix"
                     ref="prefix">
                    <slot name="prefix"></slot>
                </div>
                <div class="m-input-style__content">
                    <slot />
                </div>
                <div class="m-input-style__suffix"
                     ref="suffix"
                     v-if="$slots.suffix || isWaiting">
                    <slot name="suffix" />
                    <m-spinner v-if="isWaiting"
                               class="m-input-style__spinner"
                               size="small" />
                </div>
            </div>
        </div>
        <div v-if="append && $slots.append"
             ref="append"
             class="m-input-style__append">
            <slot name="append" />
        </div>
    </div>
    <slot name="popup"></slot>
    <div v-if="$slots['validation']" class="m-input-style__validation">
        <slot name="validation" />
    </div>
</div>
